<section class="bg-gradient-to-b from-gray-50 to-white py-12 md:py-20">
  <div
    class="bg-white shadow-strong rounded-3xl p-8 md:p-16 md:mx-10 lg:mx-20 mt-5 md:mt-10 overflow-hidden relative"
  >
    <!-- Decorative elements -->
    <div
      class="absolute top-0 right-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl -z-0"
    ></div>
    <div
      class="absolute bottom-0 left-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -z-0"
    ></div>

    <div class="relative z-10">
      <div class="inline-block">
        <h1
          class="text-3xl md:text-5xl font-bold text-primary mb-6 animate-fadeInUp"
        >
          Quiénes Somos
        </h1>
        <div
          class="h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
        ></div>
      </div>

      <div
        class="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6 animate-fadeInUp"
        style="animation-delay: 0.2s"
      >
        <p class="text-lg">
          Everfull es una empresa dedicada a la purificación del agua con
          <strong class="text-primary">más de 30 años de trayectoria</strong>,
          siempre en crecimiento y orientada a la innovación con
          <strong class="text-primary">tecnología de última generación</strong>.
        </p>

        <p class="text-lg">
          <strong class="text-primary"
            >Nos especializamos en la instalación y mantenimiento de
            dispensadores y purificadores de agua fría y caliente</strong
          >, conectados directamente a la red para ofrecer agua libre de
          impurezas a la temperatura ideal.
        </p>

        <p class="text-lg">
          Contamos con una línea de
          <strong class="text-primary"
            >equipos de alto rendimiento y fácil instalación</strong
          >, con modelos diseñados para adaptarse a cualquier tipo de espacio,
          tanto en
          <strong class="text-primary">Empresas como en Hogares</strong>.
        </p>

        <div
          class="bg-gradient-to-r from-secondary/10 to-primary/10 p-6 rounded-2xl border-l-4 border-secondary"
        >
          <p class="text-lg font-medium">
            <strong class="text-secondary"
              >No requieren botellones ni plásticos descartables</strong
            >, contribuyendo al cuidado del medio ambiente y garantizando
            <strong class="text-secondary"
              >agua purificada en forma ilimitada</strong
            >.
          </p>
        </div>

        <p class="text-lg">
          Nuestros purificadores y dispensadores
          <strong class="text-primary"
            >cumplen con normas de seguridad eléctrica</strong
          >. Incorporan un filtro de sedimentos de un micrón y un filtro de
          carbón activado en bloque con iones de plata, ambos
          <strong class="text-primary">certificados por ANMAT</strong>.
        </p>

        <p class="text-lg">
          Contamos con la
          <strong class="text-primary"
            >capacidad técnica necesaria para brindar un servicio confiable y de
            alta calidad</strong
          >. Disponemos de personal especializado, procesos estandarizados y
          equipamiento profesional que aseguran los más altos niveles de
          desempeño.
        </p>

        <p class="text-lg">
          Cada intervención es realizada por
          <strong class="text-primary"
            >técnicos formados y experimentados</strong
          >, lo que garantiza trabajos precisos, seguros y alineados con las
          normativas vigentes.
        </p>

        <p class="text-lg">
          Sostenemos un
          <strong class="text-primary"
            >compromiso permanente con nuestros clientes</strong
          >, priorizando la transparencia y la atención personalizada. Nuestro
          objetivo es ofrecer soluciones ágiles y eficaces, generando una
          experiencia positiva en cada instancia.
        </p>

        <p class="text-lg">
          Trabajamos día a día para
          <strong class="text-primary"
            >optimizar nuestros procesos, incorporar nuevas herramientas y
            mejorar continuamente</strong
          >
          con el fin de alcanzar resultados que superen las expectativas.
          Valoramos la
          <strong class="text-primary"
            >responsabilidad, la seriedad y el cumplimiento</strong
          >
          como pilares fundamentales para fortalecer cada relación comercial.
        </p>

        <div
          class="bg-gradient-to-r from-primary to-blue-900 p-8 rounded-2xl text-white text-center mt-8 shadow-medium"
        >
          <p class="text-2xl md:text-3xl font-bold mb-3">
            Unite y viví una experiencia única con nosotros
          </p>
          <p class="text-lg md:text-xl">
            <span class="font-semibold">Everfull</span> - Agua en su mejor
            versión
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
